import React from 'react';

// Original Hindi content written for GoGoYonoGames
const HindiInfoSection = () => {
  return (
    <section className="w-full bg-gradient-to-b from-white to-purple-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 text-gray-800">
        <h2 className="text-2xl sm:text-3xl font-bold mb-4 text-gray-900">
          GoGoYonoGames — नए Yono Games और Earning Apps का ठिकाना
        </h2>
        <p className="text-sm sm:text-base leading-relaxed text-gray-700 mb-4">
          <strong>GoGoYonoGames</strong> पर आपको भारत के सबसे नए और भरोसेमंद
          Yono Rummy, Slots, Teen Patti और Bet apps की पूरी लिस्ट मिलेगी।
          हर app के साथ आपको मिलता है welcome bonus, joining bonus, refer
          & earn कमाई और सिर्फ ₹100 से withdrawal की सुविधा।
        </p>

        <h3 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-900">
          Yono Apps क्या होते हैं?
        </h3>
        <p className="text-sm sm:text-base leading-relaxed text-gray-700 mb-4">
          Yono apps वो online gaming apps होते हैं जिनमें आप Rummy, Teen Patti,
          Ludo, Slots और mini games खेल कर असली पैसा कमा सकते हैं। हर नए user
          को साइन-अप पर <strong>₹36 से ₹500 तक का free bonus</strong> मिलता है
          और आप UPI, Paytm या bank account में सीधे पैसा withdraw कर सकते हैं।
        </p>

        <h3 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-900">
          GoGoYonoGames से app कैसे download करें?
        </h3>
        <ol className="list-decimal pl-6 space-y-2 text-sm sm:text-base text-gray-700 mb-6">
          <li>ऊपर दी गई list में से कोई भी app चुनें जो आपको पसंद आए।</li>
          <li>App पर tap करें — detail page खुलेगा जहाँ पूरी जानकारी होगी।</li>
          <li>“Download App” button दबाएँ और APK file अपने phone में save करें।</li>
          <li>Install करें, mobile number से register करें और OTP verify करें।</li>
          <li>Bank / UPI details add करें और अपना welcome bonus claim करें।</li>
        </ol>

        <h3 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-900">
          कौन-कौन से Yono Games उपलब्ध हैं?
        </h3>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm sm:text-base text-gray-700 mb-6 pl-6 list-disc">
          <li><strong>Rummy Apps</strong> — Yono Rummy, IND Rummy, Max Rummy, Top Rummy, Joy Rummy, Boss Rummy और भी बहुत।</li>
          <li><strong>Slots & Spin Apps</strong> — Spin 777, Diwa Top, Saga Slots, Good Slots, Spin Gold, Yn Slots, Spin Winner।</li>
          <li><strong>Teen Patti Apps</strong> — Real Teen Patti, Teen Patti Neta, Teen Patti Gold Vip, Namaste Teen Patti।</li>
          <li><strong>Bet Games</strong> — MQM Bet, MDM Bet, MKM Bet, MSM Bet, Bet 213, Bet 54, Bet 11।</li>
          <li><strong>777 Series</strong> — Diwa 777, Yono 777, SVIP 777, Ez 777, Mani 777, Ever 777।</li>
          <li><strong>Special New</strong> — Rummy Ludo, Crown 11, Bingo 101, Yono Arcade, 5222 Game।</li>
        </ul>

        <h3 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-900">
          पैसे कैसे कमाएँ इन apps से?
        </h3>
        <ul className="list-disc pl-6 space-y-2 text-sm sm:text-base text-gray-700 mb-6">
          <li><strong>Welcome Bonus:</strong> हर नए user को ₹36 से ₹500 तक free बोनस मिलता है।</li>
          <li><strong>Refer & Earn:</strong> दोस्तों को invite करके 10% से 30% तक lifetime commission कमाएँ।</li>
          <li><strong>Daily Login Bonus:</strong> रोज़ app खोलने पर free coins और cash rewards।</li>
          <li><strong>Game Winnings:</strong> Rummy, Teen Patti, Slots जीत कर सीधे bank में पैसे लें।</li>
          <li><strong>Tournaments:</strong> बड़े prize pool वाले contests में हिस्सा लें।</li>
        </ul>

        <h3 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-900">
          Withdrawal कितनी जल्दी होता है?
        </h3>
        <p className="text-sm sm:text-base leading-relaxed text-gray-700 mb-4">
          इन सभी Yono apps पर <strong>minimum ₹100</strong> से withdrawal शुरू
          होता है। पैसा IMPS, UPI या NEFT से आमतौर पर <strong>5 से 30 मिनट</strong>
          के अंदर आपके bank account में आ जाता है। कुछ apps पर instant UPI
          transfer भी available है।
        </p>

        <div className="mt-6 bg-amber-50 border border-amber-200 rounded-lg p-4">
          <h4 className="font-bold text-amber-900 mb-2">⚠️ ज़रूरी सूचना (Disclaimer)</h4>
          <p className="text-sm text-amber-900 leading-relaxed">
            18 साल से कम उम्र के लोगों को यह games नहीं खेलने चाहिए। इन apps में
            असली पैसे का लेन-देन होता है इसलिए loss का जोखिम है। हमेशा अपनी
            क्षमता के अनुसार ही खेलें। GoGoYonoGames सिर्फ इन apps की जानकारी देता
            है — किसी भी नुकसान के लिए हम ज़िम्मेदार नहीं हैं।
          </p>
        </div>

        <h3 className="text-xl sm:text-2xl font-semibold mt-8 mb-3 text-gray-900">
          अक्सर पूछे जाने वाले सवाल (FAQs)
        </h3>
        <div className="space-y-4">
          <div>
            <p className="font-semibold text-gray-900">Q1. क्या ये सारे Yono apps safe हैं?</p>
            <p className="text-sm sm:text-base text-gray-700">
              हाँ, GoGoYonoGames पर लिस्ट किए गए सभी apps को verify करके ही जोड़ा
              जाता है। हर app में secure UPI payment और OTP verification होता है।
            </p>
          </div>
          <div>
            <p className="font-semibold text-gray-900">Q2. क्या iOS पर भी ये games चलते हैं?</p>
            <p className="text-sm sm:text-base text-gray-700">
              ज़्यादातर apps सिर्फ Android APK में आते हैं। कुछ apps का iOS version
              भी है, detail page पर आपको पूरी जानकारी मिलेगी।
            </p>
          </div>
          <div>
            <p className="font-semibold text-gray-900">Q3. Bonus कब मिलता है?</p>
            <p className="text-sm sm:text-base text-gray-700">
              Mobile number से sign-up और OTP verify होते ही welcome bonus आपके
              wallet में instantly credit हो जाता है।
            </p>
          </div>
          <div>
            <p className="font-semibold text-gray-900">Q4. Refer करने पर कितना पैसा मिलता है?</p>
            <p className="text-sm sm:text-base text-gray-700">
              हर app के अलग-अलग referral rates होते हैं — आमतौर पर 10% से 30% तक
              lifetime commission मिलता है जब आपका दोस्त game खेलता है।
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HindiInfoSection;
